import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import CircleLoader from '@lib/components/CircleLoader/CircleLoader';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import useDepartmentHierarchyTree from './useDepartmentHierarchyTree';
import DepartmentHierarchyTreeNode from './DepartmentHierarchyTreeNode';
import styles from './DepartmentHierarchyView.module.scss';

type Props = {
  departmentId: string;
};

export default function DepartmentHierarchyView({ departmentId }: Props) {
  const { t } = useTranslation();
  const {
    roots,
    loading,
    expandedIds,
    loadingIds,
    childrenByParentId,
    toggleExpand,
  } = useDepartmentHierarchyTree(departmentId);

  return (
    <div className={classNames(entityViewStyles.infoItemCol, styles.container)}>
      <p className={entityViewStyles.infoItemTitle}>
        <MaterialIcon icon="rebase" symbolsOutlined />
        <Typography variant="caption">{t('department-hierarchy')}</Typography>
      </p>
      <div className={styles.wrapper}>
        {loading ? (
          <div className={styles.loadingWrapper}>
            <CircleLoader
              size={24}
              padding="8px 0"
              classes={{ root: styles.loadingIconRoot }}
            />
          </div>
        ) : (
          <ul className={styles.tree}>
            {roots.map((root) => (
              <DepartmentHierarchyTreeNode
                key={root.id}
                node={root}
                currentDepartmentId={departmentId}
                expandedIds={expandedIds}
                loadingIds={loadingIds}
                childrenByParentId={childrenByParentId}
                onToggle={toggleExpand}
              />
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
